export const COLORS = {
  mcPepeYellow: '#F1B82E',
  mcPepeRed: '#792626',
  black: '#323232',
  white: '#FFFFFF',
  gray: '#d5d5d5',
  red: '#F80606',
}
